import React from 'react';
import './footer.css';
import {Link} from "react-router-dom";
import {footer} from "../../data";


function App() {
  return (
    <Group2122
      group862Props={group2122Data.group862Props}
      group872Props={group2122Data.group872Props}
      group322Props={group2122Data.group322Props}
      frame5Props={group2122Data.frame5Props}
    />
  );
}

export default App;

function Group2122(props) {
  const { group862Props, group872Props, group322Props, frame5Props } = props;

  return (
    <div 
className="fm-group-212">
      <div 
className="fm-flex-row">
        <Group8622 group85={group862Props.group85} />
        <Group872
          facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
          facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
          twitterProps={group872Props.twitterProps}
        />
      </div>
      <Group322 {...group322Props} />
      <Frame5
        quickLinks={frame5Props.quickLinks}
        frame140Props={frame5Props.frame140Props}
        frame1402Props={frame5Props.frame1402Props}
        frame1403Props={frame5Props.frame1403Props}
      />
    </div>
  );
}


function Group8622(props) {
  const { group85 } = props;

  return (
    <Link to="/home">
    <div 
className="fm-group-86">
      <div 
className="fm-white">
        <img
          
className="fm-vector"
          //src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img 
      className="fm-group-85" 
      src={footer.Webuildd} />
    </div>
    </Link>
  );
}


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div 
className="fm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div 
className="fm-facebook-app-symbol">
      <img 
      className="fm-f-1" 
      src={footer.Facebook} />
     
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div 
className="fm-instagram">
      <div 
className="fm-overlap-group" >  {/*  style={{ backgroundImage: `url(${overlapGroup1})` }}  */}
        <img 
        src={footer.Instagram} 
        width='16px'
        height='16px'
        />
        {/* <img
//        className="fm-vector-1"
//        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
//         /> */}
        {/* <img 
        className="fm-vector-2" 
        src={vector2} /> */}
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div 
className="fm-twitter">
      <img 
      className="fm-vector-3" 
      src={footer.Twitter} />
    </div>
  );
}


function Group322(props) {
  const { place, overlapGroup, phone, overlapGroup1, vector2, text165, text164, contactWebuildCom } = props;

  return (
    <div 
className="fm-group-32">
      <div 
className="fm-place fm-valign-text-middle lpm-typographyheadlineh5-extrabold-20">{place}</div>
      <div 
className="fm-flex-row-1">
        <div 
className="fm-flex-col">
          <div 
className="fm-map-pin-1">
            <div className="fm-overlap-group-1" >  {/* style={{ backgroundImage: `url(${overlapGroup})` }} */}
              <img 
              src={footer.Map}
              width='16px'
              height='14px'
              />
            </div>
          </div>
          <div 
          className="fm-phone" > {/* style={{ backgroundImage: `url(${phone})` }} */}
            <img
            src={footer.Phone}
            width='16px'
            height='14px'
            />
          </div>
          <div 
            className="fm-mail">
            <div 
              className="fm-overlap-group1" >   {/* style={{ backgroundImage: `url(${overlapGroup1})` }} */}
              <img 
              src={footer.Mail}
              width='16px'
              height='14px'
              />
              {/* <img 
              className="fm-vector-5" src={vector2} /> */}
            </div>
          </div>
        </div>
        <div 
className="fm-flex-col-1">
          <p 
className="fm-text-2 lpm-typography-body-smalltext-14-regular">{text165}</p>
          <div 
className="fm-flex-col-item fm-valign-text-middle lpm-typography-body-smalltext-14-regular">{text164}</div>
          <div 
className="fm-flex-col-item fm-valign-text-middle lpm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div 
className="fm-frame-5">
      <div 
className="fm-quick-links fm-valign-text-middle lpm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div 
className="fm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} urlFirst={frame140Props.urlFirst} urlSecond={frame140Props.urlSecond} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          urlFirst={frame1402Props.urlFirst}
          urlSecond={frame1402Props.urlSecond}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          urlFirst={frame1403Props.urlFirst}
          urlSecond={frame1403Props.urlSecond}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects,urlFirst,urlSecond, className } = props;

  return (
    <div className={`fm-frame-140 ${className || ""}`}>
      <Link to = {`${urlFirst}`}>
        <div className="fm-about-us fm-valign-text-middle lpm-typographybody16-regular">
          {aboutUs}
        </div>
      </Link>
      <Link to = {`${urlSecond}`}>
        <div className="fm-projects fm-valign-text-middle lpm-typographybody16-regular">
          {projects}
        </div>
      </Link>
    </div>
  );
}

const group8622Data = {
    // group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-17@2x.svg",
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
    
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/instagram-1@2x.svg",
    //vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
    
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d434f90f59a872fbd1cefc/img/twitter@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

const group322Data = {
    place: "Contact",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/map-pin--1--1@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d70c933a473832a7d2b923/img/phone-1@2x.svg",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-152@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-153@2x.svg",
    text165: " BSR Memoirs, No. 15, New BEL Road, Chikkamaranahalli, RMV 2nd Stage Bangalore 560094, Karnataka.",
    text164: "+91-9845408111",
    contactWebuildCom: "hari.krishna@webuildd.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
    urlFirst: "/about",
    urlSecond: "/project",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    urlFirst: "/video",
    urlSecond: "/",
    className: "fm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    urlFirst: "/blog",
    urlSecond: "/faq",
    className: "fm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

const group2122Data = {
    group862Props: group8622Data,
    group872Props: group872Data,
    group322Props: group322Data,
    frame5Props: frame5Data,
};